import { CSSProperties, ReactNode, useState } from "react";
import { DropdownMenu } from "../DropdownMenu";
import { Colors } from "../../utils/colors";
import DropdownArrowIcon from "./DropdownArrowIcon";

type DropdownFilterProps = {
  items: any[];
  filterState: string | ReactNode;
  containerStyles?: CSSProperties;
};

// A dropdown filter component that filters a list of items
const DropdownFilter = (props: DropdownFilterProps) => {
  const { items, filterState, containerStyles } = props;
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const styles = {
    filterContainer: {
      gap: 10,
      borderRadius: 8,
      paddingInline: 14,
      paddingBlock: 12,
      backgroundColor: Colors.WHITE1,
      border: `0.8px solid ${Colors.GRAY2}`,
      ...containerStyles,
    },
  };

  return (
    <DropdownMenu
      dropdownItems={items}
      trigger={["click"]}
      placement="bottom"
      onOpenChange={(isOpen: boolean) => setDropdownVisible(isOpen)}
      altWidth={160}
    >
      <div className="AlignedRowSelect" style={styles.filterContainer}>
        {typeof filterState === "string" ? (
          <span className="bodyMedium">{filterState}</span>
        ) : (
          filterState
        )}
        <DropdownArrowIcon isOpen={dropdownVisible} height={14} />
      </div>
    </DropdownMenu>
  );
};

export default DropdownFilter;
